<template>
  <footer class="app-footer" id="contact">
    <div class="container">
      <div class="footer-grid">
        <div class="footer-brand">
          <div class="footer-brand-row">
            <img
              src="/logo.png"
              alt="ELTTEC 易伦特科技"
              class="footer-logo-img"
              height="40"
            />
          </div>
          <p class="footer-desc">{{ $store.getters.t('footer.desc') }}</p>
        </div>
        <div class="footer-col">
          <h4 class="footer-heading">{{ $store.getters.t('footer.productsTitle') }}</h4>
          <ul>
            <li><a href="/#ssms" @click.prevent="scrollTo('ssms')">{{ $store.getters.t('footer.productLinks.ssms') }}</a></li>
            <li><a href="/#eom" @click.prevent="scrollTo('eom')">{{ $store.getters.t('footer.productLinks.eom') }}</a></li>
            <li><a href="/#rpa" @click.prevent="scrollTo('rpa')">{{ $store.getters.t('footer.productLinks.rpa') }}</a></li>
            <li><router-link to="/digital-automation">{{ $store.getters.t('footer.productLinks.dauto') }}</router-link></li>
          </ul>
        </div>
        <div class="footer-col">
          <h4 class="footer-heading">{{ $store.getters.t('footer.contactTitle') }}</h4>
          <p class="footer-contact">{{ $store.getters.t('footer.phone') }}</p>
          <p class="footer-contact">{{ $store.getters.t('footer.email') }}</p>
          <p class="footer-contact">{{ $store.getters.t('footer.address') }}</p>
        </div>
      </div>
      <div class="footer-bottom">
        <p class="footer-copyright">{{ $store.getters.t('footer.copyright') }}</p>
        <p class="footer-icp">{{ $store.getters.t('footer.icp') }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  methods: {
    scrollTo(id) {
      if (this.$route.path !== '/') {
        this.$router.push('/').then(() => this.$nextTick(() => {
          const el = document.getElementById(id)
          if (el) el.scrollIntoView({ behavior: 'smooth' })
        }))
      } else {
        const el = document.getElementById(id)
        if (el) el.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
.app-footer {
  background: rgba(8,14,26,.98);
  border-top: 1px solid rgba(255,255,255,.04);
  padding: 64px 0 0;
}
.footer-grid {
  display: grid;
  grid-template-columns: 1.8fr 1fr 1fr;
  gap: 48px;
  padding-bottom: 44px;
  border-bottom: 1px solid rgba(255,255,255,.04);
}
.footer-brand-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}
.footer-logo-img {
  height: 40px;
  width: auto;
  display: block;
  filter: drop-shadow(0 0 14px rgba(59,130,246,.18));
}
.footer-desc { color: #64748b; font-size: 13.5px; line-height: 1.75; max-width: 360px; }
.footer-heading { color: #cbd5e1; font-size: 14px; font-weight: 600; margin-bottom: 18px; letter-spacing: .02em; }
.footer-col ul { list-style: none; }
.footer-col li { margin-bottom: 10px; }
.footer-col a { color: #64748b; font-size: 13.5px; transition: color 0.25s; cursor: pointer; }
.footer-col a:hover { color: #60a5fa; }
.footer-contact { color: #64748b; font-size: 13.5px; margin-bottom: 8px; }
.footer-bottom {
  text-align: center;
  padding: 28px 0;
}
.footer-copyright {
  color: #475569;
  font-size: 13px;
  margin-bottom: 4px;
}
.footer-icp {
  color: #334155;
  font-size: 12px;
}
@media (max-width: 768px) {
  .footer-grid { grid-template-columns: 1fr; gap: 32px; }
  .footer-bottom { padding: 20px 0; }
}
</style>
